import styled from 'styled-components';

export const ModalContent = styled.div`
  padding: 20px;
  margin-bottom: 1px;
`;

export const DoctorInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
`;

export const DoctorDetails = styled.div`
  margin-left: 20px;
`;

export const AppointmentDetails = styled.div`
  margin-left: auto;
  text-align: right;
`;

export const SingleButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 40px;
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 70px;
  margin-top: 1px;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 2px solid #CCCCCC;
  margin: 10px 0;
`;

export const Container = styled.div`
  max-width: 800px;
  width: 100%;
  margin: 40px auto;
  padding: 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

export const Content = styled.div`
  padding: 20px;
`;

export const Title = styled.h2`
  color: #00608a;
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: center;
`;

export const Subtitle = styled.p`
  color: #6c757d;
  font-size: 16px;
  margin-bottom: 30px;
  text-align: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  color: #212529;
  display: block;
  font-size: 16px;
  margin-bottom: 5px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  font-size: 16px;
`;

export const Select = styled.select`
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 16px;
  padding: 10px;
  width: 100%;
`;

export const DireccionBox = styled.div`
  background-color: #ddf7f7;
  padding: 15px;
  border-radius: 5px;
  margin-top: 20px;
  display: flex;
  align-items: center;
`;

export const Icon = styled.i`
  font-size: 24px;
  margin-right: 10px;
  color: #00cfd4; /* Color del ícono */
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;

export const Button = styled.button`
  background-color: ${props => props.secondary ? '#fff' : '#00cfd4'};
  border: ${props => props.secondary ? '1px solid #6c757d' : 'none'};
  border-radius: 20px;
  color: ${props => props.secondary ? '#6c757d' : '#fff'};
  cursor: pointer;
  font-size: 16px;
  padding: 10px 20px;
  min-width: 150px;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${props => props.secondary ? '#f8f9fa' : '#00bfc4'};
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap; /* ✅ Esto permite que los hijos salten de línea */
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const Col = styled.div`
  flex: 1;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }

  @media (max-width: 768px) {
    flex: 100%;      /* ✅ fuerza que ocupe todo el ancho */
    margin-right: 0; /* ✅ evita separación lateral */
    margin-bottom: 10px;
  }
`;

export const PhoneInputWrapper = styled.div`
  width: 100%;
`;

export const FlagIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 8px;
`;

export const CountryCode = styled.span`
  margin-right: 8px;
  font-weight: bold;
`;

export const DoctorImage = styled.img`
  height: 80px;
  width: 80px;
  border-radius: 50%;

  @media (max-width: 768px) {
    display: none; 
  }
`;

export const Specialty = styled.p`
  font-weight: bold;
  color: #00cfd4;
  margin: 0;
`;

export const DoctorName = styled.p`
  margin: 0;
`;

export const Date = styled.div`
  font-weight: bold;
`;

export const LocationTime = styled.div`
  font-size: 16px;
  color: #6c757d;
`;

export const IconoUbicacion = styled.i`
  color: #00bfc4;
  margin-right: 8px;
  font-size: 18px;
`;

export const IconoReloj = styled.i`
  color: #00bfc4;
  margin-right: 8px;
  font-size: 18px;
`;

export const CardTitle = styled.h4`
  color: #00cfd4;
  font-size: 18px;
  margin-bottom: 15px;
`;

export const InputFocusAzul = styled.input`
  border: 1px solid #00788C;
  border-radius: 0.25rem;
  height: 40px;
  padding: 0 12px;
  color: #000;

  &:focus {
    border-color: #00b6c6;
    outline: none;
    box-shadow: none;
  }
`;

export const ModalCardTitle = styled.h5`
  display: flex;
  align-items: center;
  color: #00A3AD;
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 18px;

  img {
    width: 24px;
    margin-right: 8px;
  }
`;

export const ModalText = styled.div`
  color: #4A4A4A;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 4px;
`;

export const ModalSubText = styled.div`
  color: #6F6F6F;
  font-size: 14px;
  font-weight: 400;
`;

export const ModalInfoText = styled.div`
  color: #4A4A4A;
  font-size: 14.5px;
  margin-bottom: 5px;
  font-weight: 400;
`;